module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-pagination-white-697b0a4f0058adb3c42a88d715905c38.svg";